import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { type SxProps } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { ProgressCarousel } from "@src/appV2/redesign/components/ProgressCarousel";
import { TopLeftBackButton } from "@src/appV2/redesign/components/TopLeftBackButton";

interface StartRecapStepProps {
  onNext: () => void;
  onBack: () => void;
  sx?: SxProps;
  progressCarousel?: {
    currentIndex: number;
    totalSteps: number;
    onIndexChange: (index: number) => void;
  };
}

export function StartRecapStep(props: StartRecapStepProps) {
  const { onNext, onBack, sx, progressCarousel } = props;

  return (
    <Stack
      spacing={6}
      alignItems="center"
      sx={{
        width: "100%",
        height: "100%",
        justifyContent: "space-between",
        ...sx,
      }}
    >
      <Box sx={{ width: "100%" }}>
        <TopLeftBackButton iconType="chevron-left" onClick={onBack} />
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 5,
        }}
      >
        <Text variant="h1" sx={{ textAlign: "center", maxWidth: 343 }}>
          Let&apos;s recap what we&apos;ve learned!
        </Text>
      </Box>

      <Stack spacing={3} sx={{ width: "100%" }}>
        {progressCarousel && (
          <ProgressCarousel
            currentIndex={progressCarousel.currentIndex}
            totalCount={progressCarousel.totalSteps}
            onIndexChange={progressCarousel.onIndexChange}
          />
        )}
        <Button
          fullWidth
          size="large"
          variant="contained"
          sx={{ borderRadius: 999, height: 56 }}
          onClick={onNext}
        >
          Begin review
        </Button>
      </Stack>
    </Stack>
  );
}
